import { render, staticRenderFns } from "./PlatformTable.vue?vue&type=template&id=c97af3ce&scoped=true"
import script from "./PlatformTable.vue?vue&type=script&lang=js"
export * from "./PlatformTable.vue?vue&type=script&lang=js"
import style0 from "./PlatformTable.vue?vue&type=style&index=0&id=c97af3ce&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c97af3ce",
  null
  
)

export default component.exports